import { memo } from "react";
import { LuArrowLeft, LuSearch, LuShoppingCart } from "react-icons/lu";
import { useCart } from "../hooks/useCart";

/** Sticky header: back, title / subtitle, optional search and the cart with its count. */
function ShopHeader({ title, subtitle, onBack, onSearch, searchOpen, centered = false, showCart = true, children }) {
  const { count } = useCart();
  return (
    <header className={`ep-header ${centered ? "is-centered" : ""}`}>
      {onBack && (
        <button type="button" className="ep-icon-btn is-back" aria-label="Go back" onClick={onBack}>
          <LuArrowLeft />
        </button>
      )}
      <div className="ep-header-title">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {children}
      {onSearch && (
        <button
          type="button"
          className="ep-icon-btn"
          aria-label={searchOpen ? "Close search" : "Search products"}
          aria-expanded={searchOpen}
          onClick={onSearch}
        >
          <LuSearch />
        </button>
      )}
      {showCart && (
      <span
        className="ep-icon-btn"
        role="img"
        aria-label={count ? `Cart, ${count} item${count === 1 ? "" : "s"}` : "Cart is empty"}
      >
        <LuShoppingCart aria-hidden="true" />
        {count > 0 && (
          <span className="ep-badge-count" aria-hidden="true">
            {count > 99 ? "99+" : count}
          </span>
        )}
      </span>
      )}
    </header>
  );
}

export default memo(ShopHeader);
